import { Children, createRef, ReactNode, RefObject, useMemo } from 'react';
import { ElementsRefs } from './MasonryGallery.types';

export const useChildrenElementsRefs = (children: ReactNode): ElementsRefs => ({
  elementsRefs: useMemo<RefObject<HTMLDivElement>[]>(() => {
    return (Children.toArray(children) || []).map(() => createRef());
  }, [children]),
});
